import { jwtDecode } from "jwt-decode";

import { PUID_KEY } from "@/constants/api";
import type { JWTAccessToken } from "@/types/api";

import { getCookie, setCookie } from "../actions";
import { AnalyticParams } from "../constants";

export const getPuidFromAccessToken = (accessToken: string) => {
  const decodedToken = jwtDecode<JWTAccessToken>(accessToken);

  const puid = decodedToken[PUID_KEY];

  if (typeof puid !== "string") return;

  return puid;
};

export const getPuid = () => getCookie(AnalyticParams.PERS_UID);

export const initializePuid = (accessToken: string) => {
  const personalId = getPuidFromAccessToken(accessToken);

  if (!personalId) return;

  setCookie(AnalyticParams.PERS_UID, personalId);

  return personalId;
};
